import React from "react";
import { useTranslation } from "react-i18next";
import SessionSaverDialog from "./SessionSaverDialog";

/**
 * Professional Save Session Section Component
 * Displays when user has completed enough darts but hasn't generated statistics yet
 */
const SaveSessionSection = ({ shouldShow = false }) => {
  const { t } = useTranslation();

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="max-w-4xl mx-auto mt-8">
      <div className="bg-secondary/20 backdrop-blur-sm rounded-xl p-6 border border-primary/10 shadow-lg">
        <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <div className="text-center sm:text-left">
            <h3 className="text-white text-lg font-semibold mb-1">
              {t("statistics.sessionComplete")}
            </h3>
            <p className="text-gray-300 text-sm mr-4">
              {t("statistics.saveSessionDescription")}
            </p>
          </div>
          <SessionSaverDialog
            trigger={
              <button className="bg-test hover:bg-secondary hover:text-test text-primary px-6 py-2.5 rounded-lg shadow-md transition duration-200 font-medium flex items-center space-x-2 whitespace-nowrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{t("statistics.saveSession")}</span>
              </button>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default SaveSessionSection;
